import { Component, ContentChildren, Input, OnInit } from '@angular/core';

export interface StepVertical {

  id: number;
  active: boolean;
  completed: boolean;
  icon: string;
  title: string;
  description: string;

}

@Component({
  selector: 'app-header-card-no-expertos',
  templateUrl: './header-card-no-expertos.component.html',
  styleUrls: ['./header-card-no-expertos.component.css']
})
export class HeaderCardNoExpertosComponent implements OnInit {

  @Input('model') model: StepVertical;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/header-card-no-expertos/header-card-no-expertos.component.ts